'use client'

import { AbstractInput } from '../../_shared/AbstractInput.client'
import { TextArea } from './TextArea.client'

export type TextAreaInputProps = {
  name: string
  label: string
  className?: string
  placeholder?: string
  required?: boolean
  readOnly?: boolean
  asyncValidate?: (value: string) => Promise<string | undefined>
  validate?: (value: string) => string | undefined
} & StrictPick<UiComponentProps, 'aria-label' | 'id' | 'key'> &
  (
    | {
        maxRows: number
        maxLength?: never
      }
    | {
        maxRows?: never
        maxLength: number
      }
  )

export function TextAreaInput({
  name,
  label,
  maxLength,
  className,
  placeholder,
  required,
  readOnly = false,
  maxRows,
  asyncValidate,
  validate,
  id,
  'aria-label': ariaLabel,
}: TextAreaInputProps) {
  return (
    <AbstractInput
      name={name}
      required={required}
      {...(asyncValidate && { asyncValidate })}
      {...(validate && { validate: { validate } })}
      render={({ field, fieldState, formState }) => (
        <TextArea
          {...field}
          className={className}
          label={label}
          isSubmitting={formState.isSubmitting}
          isRequired={fieldState.isRequired}
          isLoading={fieldState.isValidating}
          error={fieldState.error}
          placeholder={placeholder}
          isReadOnly={readOnly}
          id={id}
          aria-label={ariaLabel}
          {...(typeof maxRows === 'number' ? { maxRows } : { maxLength })}
        />
      )}
    />
  )
}
